const objectToLowerCase = (data: any): any => {
  if (Array.isArray(data)) {
    return data.map((item) => objectToLowerCase(item));
  }

  if (data && typeof data === 'object') {
    const newObj: { [key: string]: any } = {};
    for (const key of Object.keys(data)) {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1);
      newObj[newKey] = objectToLowerCase(data[key]);
    }
    return newObj;
  }

  return data;
};

export const jsonParseWithLowerCaseKeys = (jsonString: string | undefined): any => {
  if (!jsonString) {
    return {};
  }

  const obj = JSON.parse(jsonString);
  return objectToLowerCase(obj);
};

const objectToUpperCase = (obj: any) => {
  if (obj === null || typeof obj !== 'object') {
    return;
  }

  if (Array.isArray(obj)) {
    obj.forEach((v) => objectToUpperCase(v));
    return;
  }

  for (const [key, value] of Object.entries(obj)) {
    const upperKey = key.charAt(0).toUpperCase() + key.slice(1);

    if (key !== upperKey) {
      delete obj[key];
      obj[upperKey] = value;
    }

    objectToUpperCase(value);
  }
};

export const jsonParseWithUpperCaseKeys = (obj: object): string => {
  objectToUpperCase(obj);

  return JSON.stringify(obj);
};

export const splitFullNameToInitials = (fullName: string | undefined): string | undefined => {
  if (!fullName) return fullName;
  const parts = fullName.split(' ').filter(Boolean);
  const first = parts[0]?.charAt(0) ?? '';
  const last = parts.length > 1 ? (parts.at(-1)?.charAt(0) ?? '') : '';
  return `${first}${last}`;
};

export const stringToStringArray = (obj: string | string[] | null): string[] => {
  if (Array.isArray(obj)) {
    return obj;
  } else if (typeof obj === 'string' && obj !== '') {
    return [obj];
  }
  return [];
};
